import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
const state = {
  // 加油枪号
  oilGun: '',
  // 加油金额
  amountOfRefueling: '',
  // 选择加油记录id
  selectOilOrderId: '',
  // 定位列表id
  gaStationId: '',
  // 定位名
  gaStation: '',
  // 优惠券Id
  couponId: '',
  // 优惠券名称
  couponText: '',
  // 优惠券折扣
  couponDiscount: '',
  // 优惠券类型
  couponType: '',
  // 发票id
  invoiceId: '',
  // 发票区号
  invoiceCode: '',
  // 发票名称
  invoiceText: '',
  // 是否是单位
  invoiceIsCompany: '',
  // 是否是添加发票
  isAddInvoice: true,
  // 路由跳转控制Login组件的header是否显示
  loginShow: true,
  // 绑定信息后台给我
  userMasge: null,
  // 需要开通钱包
  needWallet: false
}
export default {
  getters,
  actions,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/stores/pay/index.js